import { createPublicClient, http, parseUnits } from "viem";
import { avalanche } from "viem/chains";
import { ABI_RouterV1 } from "./ABI_RouterV1";
import Web3 from "web3";
import { RouterV1 } from "../const";

const PreAddLpV1 = async (
  tokenX: any,
  tokenY: any,
  amountX: number,
  amountY: number,
  address: any,
  Slippage: number,
  x?: number,
  y?: number
) => {
  try {
    const web3 = new Web3(window.ethereum as any);
    // @ts-ignore
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    console.log("Connected account:", accounts[0]);
    const contract = new web3.eth.Contract(
      ABI_RouterV1 as any,
      RouterV1
    );
    if (
      tokenX === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee" ||
      tokenY === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
    ) {
      let x_is_avax = tokenX === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
      let AVAXAmount = x_is_avax ? x : y;
      let token = x_is_avax ? tokenY : tokenX;
      let tokenAmount = x_is_avax ? amountY : amountX;
      let tokenMinAmount = x_is_avax
        ? amountY * (1 - Slippage)
        : amountX * (1 - Slippage);

      const web3Instance = new Web3(window.ethereum);
      const contractInstance = new web3Instance.eth.Contract(
        ABI_RouterV1,
        RouterV1
      );
      
      const tx = await contractInstance.methods
        .addLiquidityAVAX(
          token,
          tokenAmount.toString(),
          tokenMinAmount.toString(),
          // @ts-ignore
          (AVAXAmount * 10 ** 18).toString(),
          address,
          Math.floor(Date.now() / 1000) + 600
        )
        .send({
          from: address,
          // @ts-ignore
          value: (AVAXAmount * 10 ** 18).toString()
        });

      console.log("Giao dịch gửi đi:", tx.transactionHash);

    } else {
      const tx = await contract.methods
        .addLiquidity(
          tokenX,
          tokenY,
          BigInt(amountX),
          BigInt(amountY),
          BigInt(amountX * (1 - Slippage)),
          BigInt(amountY * (1 - Slippage)),
          address,
          BigInt(Math.floor(Date.now() / 1000) + 3600)
        )
        .send({
          from: accounts[0],
        });
    }
    return true;
  } catch (error) {
    console.log("errrrrrrrrrrrrr", error);

    return false;
  }
};

export default PreAddLpV1;
